import { render, staticRenderFns } from "./AdminRoles.vue?vue&type=template&id=11dda244&scoped=true&"
import script from "./AdminRoles.vue?vue&type=script&lang=js&"
export * from "./AdminRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dda244",
  null
  
)

export default component.exports